import baseApi from "./baseApi";

export default {
    async batchUpdate(items) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post("/trapinspections", items);
        return result.data;
    },

    /**
     * Get Trap Inspections By Plant and Date
     */
    async getTrapInspectionsByPlantAndDate(plantID, fromDate, toDate) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/trapinspections?plantID=${plantID}&fromDate=${fromDate}&toDate=${toDate}`);
        return result.data;
    },

    /**
     * Get Trap Inspections by Trap and Date
     */
    async getTrapInspectionsByTrapAndDate(trapID, fromDate, toDate) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/trapinspections?trapID=${trapID}&fromDate=${fromDate}&toDate=${toDate}`);
        return result.data;
    }
}